// A committed receipt replaces the large restored picker response. Older APIs
// ignore receipt=true and continue returning complete restored standards.
export const materialDiscardConfirmed = (discarded, propertyId, changeId) => {
  const matchingReceipt = discarded?.status === "committed"
    && Number.isSafeInteger(discarded.changeCount) && discarded.changeCount > 0;
  const matchingLegacy = discarded?.status == null
    && Number(discarded?.standards?.contactInfoId) === Number(propertyId)
    && Array.isArray(discarded?.standards?.floorplans);
  return Number(discarded?.contactInfoId) === Number(propertyId)
    && Number(discarded?.changeId) === Number(changeId)
    && discarded?.requestStatus === "discarded" && !!discarded?.discardedAtUtc
    && Number.isFinite(Date.parse(discarded.discardedAtUtc))
    && (matchingReceipt || matchingLegacy);
};
